///<reference path="../../../.jsonenv/_current_result.json.d.ts"/>

import {IUserCenterOptions} from "./user-center";

declare const mocha;

export function tryGetBaseUrl(options: Partial<IUserCenterOptions>): void {
	if (typeof mocha !== "undefined") {
		require('@gongt/jenv-data/global');
		options.userCenterBaseUrl = 'http://127.0.0.1:' + JsonEnv.accounts.debugPort;
		return;
	}
	if (process.env.USER_CENTER_URL_REWRITE) { // running debug on host
		options.userCenterBaseUrl = process.env.USER_CENTER_URL_REWRITE;
		return;
	}
	if (process.env.USER_CENTER_URL_LOCALHOST) { // running debug on host
		options.userCenterBaseUrl = 'http://127.0.0.1:' + JsonEnv.accounts.debugPort;
		return;
	}
	let JEnv;
	try {
		JEnv = require('@gongt/jenv-data').JsonEnv;
	} catch (e) {
	}
	
	if (process.env.PROJECT_NAME === 'accounts') {
		if (process.env.RUN_IN_DOCKER) {
			options.userCenterBaseUrl = 'http://127.0.0.1';
			return;
		} else {
			options.userCenterBaseUrl = 'http://127.0.0.1:' + process.env.LISTEN_PORT;
			return;
		}
	} else { // not self debug
		try {
			const {JsonEnv} = require('@gongt/jenv-data');
			if (process.env.RUN_IN_DOCKER) {
				if (!options.clientUseHttps) {
					options.clientUseHttps = true;
				}
				options.userCenterBaseUrl = 'http://' + JsonEnv.services.accounts.outerSubDomainName + '.' + JEnv.baseDomainName;
				return;
			} else {
				if (JsonEnv.accounts.debugPort && JsonEnv.accounts.debugPort != '80') {
					options.userCenterBaseUrl = 'http://' + JsonEnv.services.accounts.outerSubDomainName + '.' + JEnv.baseDomainName + ':' + JsonEnv.accounts.debugPort;
					return;
				} else {
					options.userCenterBaseUrl = 'http://' + JsonEnv.services.accounts.outerSubDomainName + '.' + JEnv.baseDomainName;
					return;
				}
			}
		} catch (e) {
		}
	}
	return null;
}
